


















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as firebase from 'firebase/app';
import Post from '@/model/Post';
import AccessType from '@/model/AccessType';
import {
  COLLECTION_ORGANIZATIONS,
  COLLECTION_POSTS,
  COLLECTION_USERS,
} from '@/model/AppConstants';
import User from '@/model/User';
import Organization from '@/model/Organization';
import FirebaseUtil from '@/model/FirebaseUtil';
import { VueEditor } from 'vue2-editor';
import VueUploadMultipleImage from 'vue-upload-multiple-image';
import StatusType from '@/model/typelist/StatusType';
import FontPicker from 'font-picker-vue';
import PostTile from '@/model/PostTile';
import PostType from '@/model/typelist/PostType';

@Component({
  components: {
    VueEditor,
    VueUploadMultipleImage,
    FontPicker,
  },
})
export default class PostComponent extends Vue {
  @Prop({ type: Object }) org!: any;

  @Prop({ type: Boolean }) showIcon!: boolean;

  apiKey = 'AIzaSyDu0fPrikYBPQ2cPC_2hd71H64yEDGLQyI';

  defaultFont = 'Roboto';

  componentKey = 1;

  loading = false;

  // VueUploadMultipleImage = new VueUploadMultipleImage()

  options = {
    families: [
      'Pacifico',
      'Suranna',
      'Dancing Script',
      'Shadows Into Light',
      'Lobster',
      'Anton',
      'Indie Flower',
      'Charmonman',
      'Kodchasan',
      'Notable',
      'Mali',
      'Roboto',
      'Srisakdi',
      'Slabo 27px',
      'Timmana',
      'Lakki Reddy',
      'Ravi Prakash',
      'Dhurjati',
    ],
  };

  activeFont = this.defaultFont;

  pickerSuffix = '';

  color = '';

  files = [] as any;

  dragtext = 'clcik me';

  filename = '';

  popupText= '';

  markIsPrimaryText= '';

  browseText = '';

  photoURL = '';

  images = [];

  dialog = false;

  items = [AccessType.publicType, AccessType.privateType];

  defaultPost = {
    comments: [],
    content: '',
    createdBy: '',
    likes: [],
    access: { ...AccessType.publicType },
    photoURL: '',
    userViews: [],
    postTile: {},
    organization: {},
  };

  post = { ...{}, ...this.defaultPost };

  $refs!: {
    fileInput: HTMLFormElement;
  };

  customToolbar = [
    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
    ['bold', 'italic', 'underline', 'strike'],
    [
      { align: '' },
      { align: 'center' },
      { align: 'right' },
      { align: 'justify' },
    ],
    ['blockquote', 'code-block'],
    [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }],
    ['link'],
    ['clean'],
  ];

  mounted() {
    this.componentKey += 1;
  }

  open() {
    this.componentKey += 1;
    console.log(this.componentKey);
    this.dialog = !this.dialog;
  }

  get userPhotoURL() {
    if (this.$store.state.freshCurrentUser) {
      return this.$store.state.freshCurrentUser.photoURL;
    }
    return '';
  }

  myFunc(selectedFont: any) {
    this.activeFont = selectedFont.family;
    (document.getElementById('ql-editor')as HTMLFormElement).style.fontFamily = selectedFont.family;
  }

  bgImg() {
    (document.getElementById('ql-editor')as HTMLFormElement).style.backgroundColor = this.color;
  }

  uploadImageSuccess(formData: any, index: any, fileList: any) {
    this.files = fileList;
  }

  // eslint-disable-next-line
  beforeRemove(index: any, done: any, fileList: any) {
    const r = true;
    if (r === true) {
      done();
    }
  }

  // eslint-disable-next-line
  editImage(formData: any, index: any, fileList: any) {
  }

  get parsedPost() {
    const postObj = new Post(
      this.post.content,
      FirebaseUtil.ObjectToRef(
        COLLECTION_USERS,
        this.$store.state.currentUser.uid,
      ),
    );
    postObj.access = { ...this.post.access };
    postObj.status = { ...StatusType.approved };
    postObj.userViews = this.post.userViews;
    const postTileObj = new PostTile();
    postTileObj.bgColor = this.color;
    postTileObj.fontFamily = this.activeFont;
    postObj.postTile = { ...postTileObj };
    postObj.type = { ...PostType.user };
    if (this.org) {
      postObj.organization = FirebaseUtil.ObjectToRef(
        COLLECTION_ORGANIZATIONS,
        this.org.id,
      );
      if (this.org.subType === null) {
        postObj.type = { ...PostType.organization };
      } else {
        postObj.type = { ...PostType.group };
      }
    }
    return postObj;
  }

  async createPost() {
    this.loading = true;
    const postData = await this.$store.dispatch('addToCollection', {
      collection: COLLECTION_POSTS,
      payload: { ...this.parsedPost },
    });
    const photoURLs = await this.loadImages(postData.id);
    await this.$store.dispatch('updateCollection', {
      collection: COLLECTION_POSTS,
      doc: postData.id,
      payload: {
        photoURLList: photoURLs,
      },
    });
    this.close();
  }

  async loadImages(postID: string) {
    const promiseArray = [] as any; // create an array for promises
    const imageArray = [] as any; // array for the images
    this.files.forEach((imageUrl: any) => {
      promiseArray.push(
        new Promise((resolve: any) => {
          const profileImageRef = firebase
            .storage()
            .ref()
            .child(`${postID}/${imageUrl.name}`);
          profileImageRef.putString(imageUrl.path, 'data_url').then(() => {
            profileImageRef.getDownloadURL().then((downloadURL: any) => {
              imageArray.push(downloadURL);
              resolve();
            });
          });
        }),
      );
    });
    await Promise.all(promiseArray); // wait for all the images to be loaded
    return imageArray;
  }

  close() {
    this.dialog = false;
    this.post.content = '';
    this.photoURL = '';
    this.color = '';
    this.bgImg();
    this.files = [];
    this.images = [];
    this.activeFont = this.defaultFont;
    this.loading = false;
  }

  get currentUser() {
    return this.$store.state.currentUser;
  }

  @Watch('showIcon')
  // eslint-disable-next-line class-methods-use-this
  onPropertyChanged(value: any, oldValue: any) {
    this.componentKey += 1;
  }
}
